import { spreadTypeDescription, spreadTypes } from '@/i18n';
import { t } from '@/i18n';
import type { SpreadMode, SpreadTypeId } from '@/types';
import styles from './SpreadTypeGrid.module.css';

interface SpreadTypeGridProps {
  mode: SpreadMode;
  value: SpreadTypeId | null;
  onChange: (id: SpreadTypeId) => void;
}

export function SpreadTypeGrid({ mode, value, onChange }: SpreadTypeGridProps) {
  const items = spreadTypes.filter((s) => s.modes.includes(mode));
  const cols4 = items.length >= 4;

  return (
    <div className={styles.block}>
      <div className={styles.slbl}>{t.spread.layoutSection}</div>
      <div className={[styles.grid, cols4 ? styles.grid4 : styles.grid3].filter(Boolean).join(' ')}>
        {items.map((s) => (
          <button
            key={s.id}
            type="button"
            title={s.name}
            className={[styles.tile, value === s.id ? styles.active : ''].filter(Boolean).join(' ')}
            onClick={() => onChange(s.id)}
          >
            <div className={styles.nm}>{s.name}</div>
            <div className={styles.ds}>{spreadTypeDescription(s, mode)}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
